import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Icon } from '../../../../layout/Icon.jsx';

const COLORS = ['#FF7A1A', '#FFB627', '#06B6D4', '#EC4899', '#22C55E', '#8B5CF6', '#EF4444', '#0EA5E9', '#6B7280'];

function defaults(r) {
  return {
    key: r?.key || '',
    name: r?.name || '',
    description: r?.description || '',
    color: r?.color || COLORS[0]
  };
}

function autoKey(name) {
  const ascii = String(name || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  if (ascii.length >= 2) return ascii.slice(0, 40);
  return `role_${Date.now().toString(36)}`;
}

export function RoleForm({ open, role, onClose, onSubmit, submitting }) {
  const isEdit = !!role;
  const { register, handleSubmit, reset, watch, setValue } = useForm({
    defaultValues: defaults(role)
  });

  useEffect(() => {
    if (open) reset(defaults(role));
  }, [open, role, reset]);

  if (!open) return null;
  const color = watch('color');

  const submit = handleSubmit((values) => {
    if (!values.name?.trim()) return;
    const body = {
      name: values.name.trim(),
      description: values.description?.trim() || '',
      color: values.color
    };
    if (!isEdit) {
      const k = values.key?.trim() || autoKey(values.name);
      body.key = k;
    }
    onSubmit?.(body);
  });

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center p-4"
      style={{ background: 'rgba(0,0,0,.45)' }}
    >
      <form
        className="card w-[460px] max-w-full"
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
        noValidate
      >
        <div className="card-h">
          <h3 className="text-[15px] font-bold flex-1">{isEdit ? 'تعديل دور' : 'دور جديد'}</h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="card-b space-y-3">
          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">الاسم *</label>
            <input className="input" {...register('name', { required: true })} />
          </div>
          {!isEdit ? (
            <div>
              <label className="block text-xs font-semibold text-ink-2 mb-1">
                المعرّف الفريد (key)
                <span className="text-ink-3 font-normal mr-1">— سيتم توليده تلقائياً إذا تُرك فارغاً</span>
              </label>
              <input
                className="input"
                placeholder="مثال: cashier"
                dir="ltr"
                {...register('key', {
                  pattern: { value: /^[a-z0-9_]*$/, message: 'أحرف لاتينية صغيرة وأرقام و _ فقط' }
                })}
              />
            </div>
          ) : null}
          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">الوصف</label>
            <textarea className="input" rows={2} {...register('description')} />
          </div>
          <div>
            <label className="block text-xs font-semibold text-ink-2 mb-1">اللون</label>
            <div className="flex items-center gap-2 flex-wrap">
              {COLORS.map((c) => (
                <button
                  key={c}
                  type="button"
                  onClick={() => setValue('color', c)}
                  className="w-7 h-7 rounded-full border-2 transition-transform"
                  style={{
                    background: c,
                    borderColor: color === c ? '#1A1B1E' : 'transparent',
                    transform: color === c ? 'scale(1.1)' : 'scale(1)'
                  }}
                  aria-label={c}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="card-h border-b-0 border-t flex justify-end gap-2">
          <button type="button" className="btn" onClick={onClose} disabled={submitting}>
            إلغاء
          </button>
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'جاري الحفظ...' : isEdit ? 'حفظ' : 'إنشاء'}
          </button>
        </div>
      </form>
    </div>
  );
}
